import { I18n } from '@calendly/i18n'

import { GuestsAllowedSwitch } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

import { useUpdateEventTypeMutation } from '../../../../api'
import { PanelContentContainer, PanelContentHeader, PanelContentTitle } from '../styles'

export const InviteeGuestsQuestion = () => {
  const { id, isGroup } = useEventType()
  const [, { isLoading }] = useUpdateEventTypeMutation({ id })

  if (isGroup) return null

  return (
    <PanelContentContainer section id="allow-guests">
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.invitee_guests')}
        </PanelContentTitle>
        <GuestsAllowedSwitch disabled={isLoading} />
      </PanelContentHeader>
    </PanelContentContainer>
  )
}
